export const EmployerLoginRedirect = '/employer/dashboard';
export const EmployerLogoutRedirect = '/account/login';
export const AdminLoginRedirect = "/admin";
export const AdminLogoutRedirect = "/account/login";
export const CandidateLoginRedirect = "/candidate/home";
export const CandidateSurveyLogoutRedirect = "/candidate/login";
export const UnauthorizedRedirect = "/unauthorized"
